export enum DataSourceCategory {
    CITY = 0,
    COUNTY = 1,
    STATE = 2,
}

export enum GAPIDataSourceCategory {
    CITY = "city",
    COUNTY = "county",
    STATE = "state",
}

export function getGAPIDataSourceCategory(dataSourceCategory: DataSourceCategory) {
    return [GAPIDataSourceCategory.CITY, GAPIDataSourceCategory.COUNTY, GAPIDataSourceCategory.STATE][
        dataSourceCategory
    ];
}

export function getDataSourceCategory(gapiDataSourceCategory: GAPIDataSourceCategory) {
    switch (gapiDataSourceCategory) {
        case GAPIDataSourceCategory.CITY:
            return DataSourceCategory.CITY;
        case GAPIDataSourceCategory.COUNTY:
            return DataSourceCategory.COUNTY;
        case GAPIDataSourceCategory.STATE:
            return DataSourceCategory.STATE;
    }
}
